import { z } from "zod";

export const updateGroupSchema = z
  .object({
    name: z.string().min(1, "Le nom du groupe ne peut pas être vide"),
    type: z.enum(["visitor", "exhibitor"]),
    visitorIds: z.array(z.object({ id: z.string() })).optional(),
    exhibitorIds: z.array(z.object({ id: z.string() })).optional(),
  })
  .refine(
    (data) => {
      if (data.type === "visitor") {
        return data.visitorIds && data.visitorIds.length > 1;
      }
      if (data.type === "exhibitor") {
        return data.exhibitorIds && data.exhibitorIds.length > 1;
      }
      return false;
    },
    (data) => ({
      message:
        data.type === "visitor"
          ? "Au moins deux visiteurs doivent être sélectionnés"
          : "Au moins deux exposants doivent être sélectionnés",
      path: data.type === "visitor" ? ["visitorIds"] : ["exhibitorIds"],
    })
  );

export const updateGroupDefaultValues: UpdateGroupForm = {
  name: "",
  type: "visitor",
  visitorIds: [],
  exhibitorIds: [],
};

export type UpdateGroupForm = z.infer<typeof updateGroupSchema>;
